import React from 'react';
import { ClipboardListIcon, PencilLineIcon, RepeatIcon, SearchCheckIcon, FolderTreeIcon, AlertCircleIcon } from 'lucide-react';
import { pillars, volumes, volumeFeatures } from '../data/volumes';
import { VolumeItem } from './VolumeItem';
const featureIcons = [ClipboardListIcon, PencilLineIcon, RepeatIcon, SearchCheckIcon, FolderTreeIcon];
export function Volumes() {
  return <section aria-label="System contents" className="bg-ink" data-id="element-353" data-mp="1zvb3o7gtq0fz">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "19px",
      paddingBottom: "23px"
    }} data-id="element-354" data-mp="1zvuobvxuz2xp">
        <div className="text-center" data-id="element-355" data-mp="24s1qrer1pwaw">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-356" data-mp="1quwg11ge099b">
            Introducing the 100+ AI Prompts for Private Security™ System
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold uppercase text-fog sm:text-4xl" data-id="element-357" data-mp="1vvaq0p1jtt9z">
            📚 Your 6-Volume Professional AI Toolkit
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-fog/70" data-id="element-358" data-mp="kfvsnk5fgzec">
            Instead of starting from a blank prompt every time, you'll have reusable instructions, customizable fields, and
            practical examples organized by professional activity.
          </p>
          <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-359" data-mp="21q6e2wiemue">
            {pillars.map(p => <li key={p} className="rounded-full border border-teal/30 bg-teal/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-teal" data-id="element-360" data-mp="3t683wsm7djhy">
                {p}
              </li>)}
          </ul>
        </div>

        <ol className="mt-9 space-y-3" data-id="element-361" data-mp="61s7a9uf7c8m">
          {volumes.map(v => <VolumeItem key={v.n} volume={v} data-id="element-362" data-mp="kr6ilnhk43qn" />)}
        </ol>

        <div className="mt-12" data-id="element-363" data-mp="ktj0k0nbee3p">
          <h3 className="text-center font-display text-2xl font-bold uppercase text-fog" data-id="element-364" data-mp="fsmzduucl61z">
            ✅ What every volume is designed to provide
          </h3>
          <ul className="mt-7 grid gap-x-8 gap-y-5 sm:grid-cols-2" data-id="element-365" data-mp="tse5l9emhi5f">
            {volumeFeatures.map((f, i) => {
            const Icon = featureIcons[i];
            return <li key={f.title} className="flex gap-3" data-id="element-366" data-mp="wuinzf41jiar" data-mpi={i}>
                  <Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-367" data-mp="wrwh7hoz56tl" />
                  <div data-id="element-368" data-mp="11qpx1grqh9wx">
                    <p className="text-sm font-bold text-fog" data-id="element-369" data-mp="16rx1b5uo3qyu">{f.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-fog/65" data-id="element-370" data-mp="16pu5u6aqx5mq">{f.desc}</p>
                  </div>
                </li>;
          })}
          </ul>
          <p className="mt-8 flex items-start gap-2.5 rounded-xl border border-gold/30 bg-gold/5 p-4 text-sm leading-relaxed text-fog/75" data-id="element-371" data-mp="1fl0ct8lr5tqu">
            <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-372" data-mp="1khh4gcs5uq8o" />
            <span data-id="element-373" data-mp="1pj6crko00pt2">
              <span className="font-bold text-gold" data-id="element-374" data-mp="1pgka9zfyt0hp">Important:</span> AI-generated material must be reviewed before use.
              Always verify facts, follow your employer's procedures, and comply with applicable privacy and documentation
              requirements.
            </span>
          </p>
        </div>
      </div>
    </section>;
}